import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../../../common/thunk';
import httpErrorHandling from '../../../../utils/httpErrorHandling';
import DashboardService from '../../../../services/dashboard.service';
import ProfessionalPatchType from '../../../../common/interfaces/Professionals/ProfessionalPatchType';
import ProfessionalResponse from '../../../../common/interfaces/Professionals/ProfessionalResponse';

interface UpdateProfessionalType {
  id: string;
  data: ProfessionalPatchType;
}
export const updateProfessional = createAppAsyncThunk('website/patch', (payload: UpdateProfessionalType) => {
  return DashboardService.updateProfessional(payload.id, payload.data);
});

interface WebsiteEditingProps {
  changed: boolean;
  error: string;
}

const initialState: WebsiteEditingProps = {
  changed: false,
  error: '',
};
export const websiteEditingSlice = createSlice({
  name: 'personalInfo',
  initialState,
  reducers: {
    confirmProfessionalChanges: state => {
      state.changed = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(updateProfessional.fulfilled, (state, action: PayloadAction<ProfessionalResponse>) => {
      if (!action.payload?.id) {
        return;
      }
      state.changed = true;
    });
    builder.addCase(updateProfessional.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(updateProfessional.pending, state => {
      state.changed = false;
      state.error = '';
    });
  },
});

export const { confirmProfessionalChanges } = websiteEditingSlice.actions;

export default websiteEditingSlice.reducer;
